module.exports = __webpack_public_path__ + "caidan.png?cff648fe9a2a461373e79d5f8b8bb396";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caidan.png
// module id = 50
// module chunks = 0